import { GlobalService } from './global.service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StorageService {
  msgErroSistema = 'Você não possui acesso a este Sistema!';
  msgErroFuncionalidade =
    'Você não possui acesso a esta funcionalidade do Sistema!';

  token: string;


  constructor(private serviceGlobal: GlobalService) {}


  cleanAccess() {
    localStorage.removeItem('access');
  }

  cleanError() {
    localStorage.removeItem('error');
  }

  cleanToken() {
    localStorage.removeItem('token');
  }

  cleanUsuarioLocal() {
    localStorage.removeItem('currentUser');
  }

  getAccess() {
    const usuarioDecrypt = this.serviceGlobal.decrypt(
      this.serviceGlobal.isNull(localStorage.getItem('access'))
    );
    if (usuarioDecrypt === '') {
      return '';
    } else {
      return usuarioDecrypt;
    }
  }

  getAccessAdministrador() {
    const usuarioDecrypt = this.serviceGlobal.decrypt(
      this.serviceGlobal.isNull(localStorage.getItem('access'))
    );
    if (usuarioDecrypt === '') {
      return '';
    } else {
      return usuarioDecrypt.administrador;
    }
  }

  getAccessCodigo() {
    const usuarioDecrypt = this.serviceGlobal.decrypt(
      this.serviceGlobal.isNull(localStorage.getItem('access'))
    );
    if (usuarioDecrypt === '') {
      return '';
    } else {
      return usuarioDecrypt.codigo;
    }
  }

  getAccessData() {
    const usuarioDecrypt = this.serviceGlobal.decrypt(
      this.serviceGlobal.isNull(localStorage.getItem('access'))
    );
    if (usuarioDecrypt === '') {
      return '';
    } else {
      return usuarioDecrypt.data;
    }
  }

  getAccessLogin() {
    const usuarioDecrypt = this.serviceGlobal.decrypt(
      this.serviceGlobal.isNull(localStorage.getItem('access'))
    );
    if (usuarioDecrypt === '') {
      return '';
    } else {
      return usuarioDecrypt.cpf;
    }
  }

  getAccessNome() {
    const usuarioDecrypt = this.serviceGlobal.decrypt(
      this.serviceGlobal.isNull(localStorage.getItem('access'))
    );
    if (usuarioDecrypt === '') {
      return '';
    } else {
      return usuarioDecrypt.nome.substring(0, usuarioDecrypt.nome.search(' '));
    }
  }

  getAccessPerfil() {
    const usuarioDecrypt = this.serviceGlobal.decrypt(
      this.serviceGlobal.isNull(localStorage.getItem('access'))
    );
    if (usuarioDecrypt === '') {
      return '';
    } else {
      return usuarioDecrypt.perfil;
    }
  }

  getAccessSetor() {
    const usuarioDecrypt = this.serviceGlobal.decrypt(
      this.serviceGlobal.isNull(localStorage.getItem('access'))
    );
    if (usuarioDecrypt === '') {
      return '';
    } else {
      return usuarioDecrypt.setor;
    }
  }

  getAccessToken() {
    const usuarioDecrypt = this.serviceGlobal.decrypt(
      this.serviceGlobal.isNull(localStorage.getItem('access'))
    );
    if (usuarioDecrypt === '') {
      return '';
    } else {
      return usuarioDecrypt.token;
    }
  }

  getAccessUsuario() {
    const usuarioDecrypt = this.serviceGlobal.decrypt(
      this.serviceGlobal.isNull(localStorage.getItem('access'))
    );
    if (usuarioDecrypt === '') {
      return '';
    } else {
      return usuarioDecrypt;
    }
  }

  getCurrentUser() {
    const usuarioDecrypt = this.serviceGlobal.decrypt(
      this.serviceGlobal.isNull(localStorage.getItem('access'))
    );
    return { currentUser: usuarioDecrypt.usuario };
  }

  getError() {
    return localStorage.getItem('error');
  }

  getToken() {
    return this.getAccess().token;
  }

  getUsuarioAtual() {
    // return JSON.parse(localStorage.getItem('currentUser'));
    return this.getAccessUsuario();
  }

  logout() {
    this.cleanError();
    this.cleanToken();
    this.cleanAccess();
    this.cleanUsuarioLocal();
  }

  permiteAcesso(exibir, parametro) {
    let msg: string;
    if (exibir) {
      this.serviceGlobal.exibirMensagem('Acesso Permitido');
    } else {
      this.serviceGlobal.exibirMensagem('Acesso Negado!');
      if (parametro === 'f') {
        msg = this.msgErroFuncionalidade;
      } else {
        msg = this.msgErroSistema;
      }
      this.serviceGlobal.exibirAlerta('warn', msg, null);
    }
  }

  setAccess(usuario) {
    const usuarioCrypt = this.serviceGlobal.encrypt(usuario);
    localStorage.setItem('access', usuarioCrypt);
  }

  setError(error: string) {
    localStorage.setItem('error', error);
  }

  setToken(token: string) {
    localStorage.setItem('token', token);
  }

  setUsuarioLocal(currentUser) {
    localStorage.setItem('currentUser', JSON.stringify(currentUser));
  }

  verificarPermissao(sistema, tipo) {
    const acessos = this.getAccessPerfil();
    this.serviceGlobal.exibirMensagem(acessos);
    const acessoSistema = acessos.find(
      (element) => element.sistema.nome === sistema
    );
    if (acessoSistema) {
      this.serviceGlobal.exibirMensagem(acessoSistema);
      switch (tipo) {
        case 'criar':
          this.permiteAcesso(acessoSistema.criar, 'f');
          if (acessoSistema.criar) {
            return true;
          } else {
            return false;
          }
        case 'editar':
          this.permiteAcesso(acessoSistema.editar, 'f');
          if (acessoSistema.editar) {
            return true;
          } else {
            return false;
          }
        case 'excluir':
          this.permiteAcesso(acessoSistema.excluir, 'f');
          if (acessoSistema.excluir) {
            return true;
          } else {
            return false;
          }
        case 'visualizar':
          this.permiteAcesso(acessoSistema.visualizar, 'f');
          if (acessoSistema.visualizar) {
            return true;
          } else {
            return false;
          }
        default:
          this.serviceGlobal.exibirAlerta(
            'warn',
            this.msgErroFuncionalidade,
            null
          );
          this.permiteAcesso(false, 'f');
          return false;
      }
    } else {
      this.serviceGlobal.exibirAlerta('warn', this.msgErroSistema, null);
      this.permiteAcesso(false, 's');
    }
  }
}
